import { FormControl, FormHelperText, InputLabel } from "@mui/material";
import { OperationSelect } from "./operation-select/operation-select";

import type { Condition } from "../../../types/segment-schema";
import type { UseMakeSortedSegmentFields } from "../hooks/use-sorted-segment-fields";
import type { FC } from "react";

export const OperationField: FC<{
  field: ReturnType<UseMakeSortedSegmentFields>["currentField"];
  segmentFields: ReturnType<UseMakeSortedSegmentFields>["fields"];
  condition: Condition;
  handleFieldChange: (value: Partial<Condition>) => void;
  disabled?: boolean;
  errMsg?: string;
}> = ({ field, condition, handleFieldChange, disabled, errMsg }) => (
  <FormControl fullWidth error={Boolean(errMsg)}>
    <InputLabel id="operator-label">Operator</InputLabel>
    <OperationSelect
      fieldType={field.field.field_type}
      condition={condition}
      handleFieldChange={handleFieldChange}
      disabled={disabled}
    />
    {errMsg && <FormHelperText>{errMsg}</FormHelperText>}
  </FormControl>
);
